const WP = {
  URL: "https://ggs.api.localhost-group.com",
  MENUS: {
    TOP_ID: "Wymagana zmiana ID w src/components/common/Menu/TopMenu",
    BOTTOM_ID: "Wymagana zmiana ID w src/components/common/Menu/BottomMenu",
  },
}
export default WP
